import VideoViewerWeb from "./VideoViewerWeb.js";
export default VideoViewerWeb;